import React from "react";
import { Button, Group, Tooltip } from "@mantine/core";
import { useAppSelector } from "../app/hooks";
import { selectProjectViewerColorTemplateName } from "./projectViewerSlice";
import { getProjectViewerColorTemplateRules } from "./projectViewerColorTemplates";

export const ProjectViewerColorLegend: React.FC = () => {
  const colorTemplateName = useAppSelector(selectProjectViewerColorTemplateName);
  const rules = getProjectViewerColorTemplateRules(colorTemplateName);

  if (!rules.length) return null;

  return (
    <Group gap="xs" wrap="wrap">
      {rules.map((rule) => (
        <Tooltip
          key={rule.id}
          multiline
          maw={420}
          label={
            <pre style={{ margin: 0, whiteSpace: "pre-wrap" }}>{JSON.stringify(rule, null, 2)}</pre>
          }
        >
          <Button
            component="div"
            size="xs"
            variant="light"
            styles={{
              root: {
                color: rule.color,
                borderColor: rule.color,
              },
            }}
            leftSection={
              <span
                aria-hidden="true"
                style={{
                  width: 10,
                  height: 10,
                  borderRadius: 2,
                  backgroundColor: rule.color,
                  border: `1px solid ${rule.color}`,
                  display: "inline-block",
                }}
              />
            }
          >
            {rule.label}
          </Button>
        </Tooltip>
      ))}
    </Group>
  );
};
